// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__A2jv3","removable":"Tag_removable__mct4E","selected":"Tag_selected__GuY6O"};